import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-btn__content" }
const _hoisted_2 = {
  key: 0,
  class: "app-btn__spinner"
}

import { computed } from 'vue'

import CircleSpinner from '@/components/ui/CircleSpinner.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    dense: { type: Boolean },
    small: { type: Boolean },
    big: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: {},
    outlined: { type: Boolean },
    primaryAlt: { type: Boolean },
    danger: { type: Boolean },
    href: {},
    tag: { default: 'button' }
  },
  setup(__props: any) {

const props = __props

const classes = computed(() => {
  return {
    'app-btn': true,
    'app-btn--dense': props.dense,
    'app-btn--small': props.small,
    'app-btn--big': props.big,
    'app-btn--disabled': props.disabled,
    'app-btn--loading': props.loading,
    'app-btn--outlined': props.outlined,
    'app-btn--primary-alt': props.primaryAlt,
    'app-btn--danger': props.danger,
  }
})

const elementTag = computed(() => {
  const tag = (props.href && 'a') || props.tag || 'div'
  return tag
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(elementTag.value), {
    class: _normalizeClass(classes.value),
    disabled: elementTag.value === 'button' && __props.disabled
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["iconfont", __props.icon])
            }, null, 2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]),
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(CircleSpinner, {
              class: "app-btn__spinner-icon",
              "animation-duration": 2000,
              size: 16
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "disabled"]))
}
}

})